import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import useQuery from '../../../../../modules/react/hooks/useQuery';
import Editor from '../../../../../modules/react/editors/Mapbox';

const GET_FACILITY = gql`
  query GetFacilityMapData($id: ID!) {
    facility(id: $id) {
      id
      location {
        coordinates
      }
    }
  }
`;

const propTypes = {
  facilityId: PropTypes.string.isRequired,
};

const defaultProps = {};

const EditorContainer = ({ facilityId, ...rest }) => {
  const { data } = useQuery(GET_FACILITY, { variables: { id: facilityId } });

  if (!data) {
    return null;
  }

  return (
    <Editor
      {...rest}
      facilityId={facilityId}
      multiFacility={false}
      facilities={[data.facility]}
    />
  );
};

EditorContainer.propTypes = propTypes;
EditorContainer.defaultProps = defaultProps;

export default EditorContainer;
